/**
 * Runtime shape guards for stream-component props. Component payloads are
 * authored by the LLM on the backend, so every registration's parseProps must
 * validate before trusting the shape — a malformed payload is dropped at
 * ingestion instead of crashing the chat at render time.
 */

export const isPlainObject = (value: unknown): value is Record<string, unknown> => {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
};

export const isStringArray = (value: unknown): value is string[] => {
  return Array.isArray(value) && value.every((item) => typeof item === 'string');
};

export const isOptionalString = (value: unknown): value is string | undefined => {
  return value === undefined || typeof value === 'string';
};
